import React from 'react';
import './style.scss';

export interface UQFormProps {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
  footer?: React.ReactNode; 
  footerAlign?: 'left' | 'center' | 'right'; 
  size?: 'small' | 'medium' | 'large'; 
  bordered?: boolean; 
  backgroundColor?: string; 
  borderRadius?: string; 
}

const UQForm: React.FC<UQFormProps> = ({
  onSubmit,
  children,
  footer,
  footerAlign = 'right', 
  size,
  bordered = false,
  backgroundColor,
  borderRadius,
}) => {
  return (
    <form
      className={`uq-form ${size ? `uq-form-${size}` : ''} ${
        bordered ? 'uq-form-bordered' : ''
      }`}
      style={{
        backgroundColor: backgroundColor || 'transparent',
        borderRadius: borderRadius || '0',
      }}
      onSubmit={onSubmit}
    >
      <div className="uq-form-content">{children}</div>
      {footer && (
        <div className={`uq-form-footer uq-form-footer-${footerAlign}`}>
          {footer}
        </div>
      )}
    </form>
  );
};

export default UQForm;